<div class="row">
  <div class="col-auto license-filter-toggle">
    <p class="advance-button" (click)="onShowHideLicensesFilter()">
      Advanced...
    </p>
    <i
      style="height: fit-content"
      class="fas advance-button"
      [ngClass]="{
        'fa-caret-right': showLicenseFilter,
        'fa-caret-down': !showLicenseFilter
      }"
      (click)="onShowHideLicensesFilter()"
    ></i>
  </div>
  <div *ngIf="showLicenseFilter" [@slideInOut] class="col-10">
    <div class="row filter-wrapper">
      <div
        *ngFor="let category of accountCategories"
        class="col-lg-4 col-md-12 col-sm-12"
      >
        <app-switch-checkbox
          bsClass="success"
          (change)="changeAccountCategory(category.code)"
          [checked]="selectedAccountCategories | checkedPipe: category.code"
        >
          {{ category.displayName }}
        </app-switch-checkbox>
      </div>
    </div>
    <app-advanced-license-filter
      [showLicenseFilter]="showLicenseFilter"
      [permissions]="permissions"
      [licenses]="licenses"
      [loadingFilter]="loadingFilter"
      [selectedLicenses]="selectedLicenses"
      [selectedPermissions]="selectedPermissions"
      (selectLicense)="selectLicense.emit($event)"
      (selectPermission)="selectPermission.emit($event)"
    ></app-advanced-license-filter>
  </div>
</div>
